import * as React from "react";

import { BlockProps } from "baseui/block";
import { DisplayLabel } from "./DisplayLabel";
import { useFormatter } from "../useFormatter";

export type TTimeDisplay = {
  answer: Date;
} & BlockProps;
export const TimeDisplay: React.FC<TTimeDisplay> = ({
  answer,
  ...restProps
}: TTimeDisplay) => {
  const shortTime = new Intl.DateTimeFormat("en", {
    timeStyle: "short",
  });
  const formattedValue = shortTime.format(new Date(answer));
  return <DisplayLabel {...restProps}>{formattedValue}</DisplayLabel>;
};
